<template>
  <transition name="fade" mode="out-in">
    <div class="screen-wrap">
      <v-app class="hmc-app" :style="intraction">
        <v-main class="main-body">
          <v-container class="app-body">
            <div class="pe-2 ps-3 app-title text-h5">
              {{ $t("string.family") }}
              <v-spacer></v-spacer>
              <CloseBtn size="40" :callback="exit" />
            </div>
            <Loader v-if="isLoading" :isLoading="isLoading" />
            <div v-else class="px-5">

              <div class="subtitle">
                {{ $t("string.familyMochiId") }}
              </div>

              <div class="mochi mb-4">
                {{ auth.Player.mochiId }}
                <v-btn small icon @click="copyToClipboard(auth.Player.mochiId)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>

              <div class="list-card d-flex mb-6 align-center pa-2" v-if="book && !isBookClaimed">
                <v-img max-width="120" v-if="book.translatableImage" :src="JSON.parse(book.translatableImage)[$_getLocale()]
                  ? JSON.parse(book.translatableImage)[$_getLocale()].url
                  : JSON.parse(book.translatableImage)[getSubjectLang()].url
                  "></v-img>

                <div class="ms-4" style="width: 100%">
                  <div v-if="auth.Player && auth.Player.userId == null">
                    <div class="text-h6 mb-2">
                      {{ $t("string.familyBannerTitle") }}
                    </div>
                    <div class="mb-2">
                      {{ $t("string.familyBannerDescription") }}
                    </div>
                  </div>
                  <div v-else class="mb-2">
                    {{ $t("string.familyBannerSuccess") }}
                  </div>
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn v-if="auth.Player && auth.Player.userId != null" class="text-h6 constant-tilt-shake mx-2"
                      color="green" dark rounded :loading="apiClaimBook.isLoading" @click="claimBook">
                      <div>{{ $t("action.claim") }}</div>
                    </v-btn>
                    <v-btn v-else color="yellow" rounded @click="expandInstructions">
                      <div>{{ $t("action.learnMore") }}</div>
                    </v-btn>
                  </div>
                </div>
              </div>
              <!-- Expandable section for instructions -->
              <v-expansion-panels v-if="auth.Player && auth.Player.userId == null" v-model="expandedPanel">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    {{ $t("string.familyInstruction") }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol class="mb-4">
                      <li>{{ $t("string.familyInstructionStep1") }}</li>
                      <li
                        v-html="$t('string.familyInstructionStep2').replace('{URL}', `<a href='${urlRegister}' target='_blank'>${urlRegister}</a>`)">
                      </li>
                      <li>{{ $t("string.familyInstructionStep3") }}</li>
                      <li>{{ $t("string.familyInstructionStep4") }}</li>
                      <li>{{ $t("string.familyInstructionStep5") }}</li>
                      <li>{{ $t("string.familyInstructionStep6") }}</li>
                      <li>{{ $t("string.familyInstructionStep7") }}</li>
                      <li>{{ $t("string.familyInstructionStep8") }}</li>
                      <li>{{ $t("string.familyInstructionStep9") }}</li>
                      <li>{{ $t("string.familyInstructionStep10") }}</li>
                      <li>{{ $t("string.familyInstructionStep11") }}</li>
                    </ol>
                    <div class="video-wrapper d-none">
                      <div class="video-container">
                        <iframe id="youtube-player" width="100%" height="100%"
                          src="https://www.youtube.com/embed/i7_rzQqrQ8s?autoplay=0&enablejsapi=1"
                          title="Hamochi Kids Official Trailer" frameborder="0"
                          allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-if="auth.Player && auth.Player.userId != null">
                <div class="subtitle mt-6">
                  {{ $t("string.familyTitle") }}
                </div>
                <div>
                  <v-card v-for="familyMember in familyMembers" :key="familyMember.mochiId" flat :class="familyMember.mochiId == auth.Player.mochiId
                    ? 'list-card-my d-flex my-2 align-center'
                    : 'list-card d-flex my-2 align-center'
                    ">
                    <AbstractAvatar v-if="familyMember.avatar" :avatar="familyMember.avatar" :height="80" :width="80">
                    </AbstractAvatar>
                    <v-img v-else max-width="80" contain :src="require('@/assets/entity/load.png')"></v-img>
                    <v-card flat color="transparent">
                      <v-card-subtitle class="py-0 gray--text text-caption" v-if="familyMember.schoolYear">
                        {{
                          $_parseSchoolYear(familyMember.schoolYear)
                        }}
                      </v-card-subtitle>
                      <v-card-title class="pt-0 pb-2 brown--text">
                        {{ familyMember.name }}
                      </v-card-title>
                      <v-card-subtitle class="pb-2" v-if="familyMember.level && familyMember.level != '-'">
                        Level {{ familyMember.level }}
                      </v-card-subtitle>
                      <v-card-text class="d-flex flex-wrap pb-2">
                        <v-img v-for="achivement in familyMember.PlayerAchievement"
                          :key="achivement.AchievementLevel.id" :src="achivement.AchievementLevel.imageUrl"
                          max-width="30">
                        </v-img>
                      </v-card-text>
                    </v-card>
                  </v-card>
                </div>
              </div>
            </div>
          </v-container>
        </v-main>
        <v-snackbar v-model="snackbar" :timeout="snackTimeout" height="10" left>
          <div class="d-flex justify-space-between">
            {{ $t("action.copied") }}
            <v-icon small> mdi-check </v-icon>
          </div>
        </v-snackbar>
        <RewardDialog v-if="claimed && claimedItem" :callbackClose="exitRwd" :showDialog="true" :rewards="[
          {
            Item: {
              images: {
                icon: JSON.parse(claimedItem.translatableImage)[$_getLocale()]
                  ? JSON.parse(claimedItem.translatableImage)[$_getLocale()]
                    .url
                  : JSON.parse(claimedItem.translatableImage)[
                    getSubjectLang(claimedItem)
                  ].url,
              },
            },
            quantity: 1,
          },
        ]" />
        <ApiErrorDialog v-if="isError" :api="apiError" />
        <Tutorial :intraction.sync="intraction" context="FAMILY"
          :condition="auth.Player && auth.Player.userId == null ? '' : 'CONNECTED'" />
      </v-app>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import AvatarSkeleton from "@/components/skeleton/Avatar";
export default {
  components: {
    AbstractAvatar: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
      loading: AvatarSkeleton,
      delay: 200,
    }),
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    RewardDialog: () =>
      import(
        /* webpackChunkName: "component-reward" */ "@/components/ABC/RewardBookDialog"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    Tutorial: () => ({
      component: import(
        /* webpackChunkName: "component-tutorial" */ "@/components/Tutorial"
      ),
    }),
  },
  computed: {
    ...mapState({
      settings: (state) => state.settings.data,
      auth: (state) => state.auth.data,
    }),
    isLoading() {
      return this.apiCheckClaim.isLoading || this.apiLoadFamily.isLoading;
    },
    isError() {
      return (
        this.apiCheckClaim.isError ||
        this.apiClaimBook.isError ||
        this.apiLoadFamily.isError
      );
    },
  },
  props: [
    //
  ],
  data: () => ({
    intraction: null,
    familyMembers: [],
    isBookClaimed: false,
    snackbar: false,
    snackTimeout: 2000,
    book: null,
    expandedPanel: null,
    apiCheckClaim: {
      isLoading: true,
      isError: false,
      error: null,
      url: null,
    },
    apiClaimBook: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    apiLoadFamily: {
      isLoading: true,
      isError: false,
      error: null,
      url: null,
    },
    apiError: null,
    claimed: false,
    claimedItem: null,
    urlRegister: null,
  }),
  async created() {
    await this.openBook();
    await this.loadFamily();
    this.urlRegister = `${process.env.VUE_APP_URL_WEB_SCHOOL}/${this.$_getLocale()}/register`;
  },
  mounted() {
    //
  },
  methods: {
    expandInstructions() {
      this.expandedPanel = 0; // Expand the first panel (index 0)
    },
    getSubjectLang() {
      if (this.book.subject == "Mandarin") {
        return "zh";
      } else if (this.book.subject == "Malay") {
        return "ms";
      } else {
        return "en";
      }
    },
    exitRwd() {
      this.claimed = false;
      this.read(this.claimedItem);
    },
    read(book) {
      this.$router.push({
        name: "PageABCBookCover",
        params: { bookKey: book.key },
      });
    },
    exit() {
      this.$router.push({
        name: "PageWorldNews",
      });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = true;
    },
    async openBook() {
      this.apiCheckClaim.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/abc/book/player/checkClaim";

      this.apiCheckClaim.callbackReset = () => {
        this.apiCheckClaim.isLoading = true;
        this.apiCheckClaim.isError = false;
        this.apiCheckClaim.error = null;
      };
      this.apiCheckClaim.callbackError = (e) => {
        this.apiCheckClaim.isLoading = false;
        this.apiCheckClaim.isError = true;
        this.apiCheckClaim.error = e;
        this.apiError = this.apiCheckClaim;
      };
      this.apiCheckClaim.callbackSuccess = (resp) => {
        this.apiCheckClaim.isLoading = false;
        this.book = resp.Book;
        this.isBookClaimed = resp.isClaimed;
      };
      this.apiCheckClaim.params = {
        bookKey: process.env.VUE_APP_FREE_BOOK_FOR_FAMILY_LINKING,
      };
      await this.$api.fetch(this.apiCheckClaim);
    },
    async claimBook() {
      this.apiClaimBook.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/abc/book/claim?isGift=1";

      this.apiClaimBook.callbackReset = () => {
        this.apiClaimBook.isLoading = true;
        this.apiClaimBook.isError = false;
        this.apiClaimBook.error = null;
      };
      this.apiClaimBook.callbackError = (e) => {
        this.apiClaimBook.isLoading = false;
        this.apiClaimBook.isError = true;
        this.apiClaimBook.error = e;
        this.apiError = this.apiClaimBook;
      };
      this.apiClaimBook.callbackSuccess = () => {
        this.claimedItem = this.book;
        this.claimed = true;
        this.apiClaimBook.isLoading = false;
      };
      this.apiClaimBook.params = {
        bookKey: this.book.key,
      };
      await this.$api.fetch(this.apiClaimBook);
    },
    async loadFamily() {
      this.apiLoadFamily.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/family/load";

      this.apiLoadFamily.callbackReset = () => {
        this.apiLoadFamily.isLoading = true;
        this.apiLoadFamily.isError = false;
        this.apiLoadFamily.error = null;
      };
      this.apiLoadFamily.callbackError = (e) => {
        this.apiLoadFamily.isLoading = false;
        this.apiLoadFamily.isError = true;
        this.apiLoadFamily.error = e;
        this.apiError = this.apiLoadFamily;
      };
      this.apiLoadFamily.callbackSuccess = (resp) => {
        this.apiLoadFamily.isLoading = false;
        this.familyMembers = resp.User;
      };
      await this.$api.fetch(this.apiLoadFamily);
    },
  },
};
</script>

<style scoped>
.subtitle {
  color: #4a3c31d7;
}

.mochi {
  color: #4a3c31;
  background-color: #83705465;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
}

.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(214, 132, 49, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}

.video-wrapper {
  width: 100%;
  padding-top: 100%;
  /* 1:1 aspect ratio */
  position: relative;
}

.video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.list-card-x {
  color: #785c3a;
  border-radius: 5px;
  border: #ccaf8b 4px solid;
  background-color: #f7efe3;
  overflow: hidden !important;
}

.list-card {
  padding: 5px;
  color: #785c3a;
  border-radius: 5px;
  border: #ccaf8b 4px solid;
  background-color: #fff9f1;
  overflow-x: hidden !important;
}

.list-card-my {
  padding: 5px;
  color: #785c3a;
  border-radius: 5px;
  border: #8e6e47 4px solid;
  background-color: #fff67f;
  overflow-x: hidden !important;
}

.constant-tilt-shake {
  animation: tilt-shaking 2s infinite;
}

.constant-tilt-shake:hover {
  animation: none;
}

@keyframes tilt-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  3% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  6% {
    transform: translate(0, 0) rotate(0eg);
  }

  9% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  12% {
    transform: translate(0, 0) rotate(0deg);
  }

  15% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  18% {
    transform: translate(0, 0) rotate(0eg);
  }

  21% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  24% {
    transform: translate(0, 0) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
</style>